import { range } from 'ramda'

// Note: These are lowercase because they correspond to the properties returned from the API and rather than convert them from the API response, we just set
// them to be lowercase here. If the API ever changes what prop it returns for some resource, you just change that resourse to be the new prop it returns here
// and it will propegrate through the app (assuming people use these dataTypes, which they should).

export const API_VERSION_ONE = 'v1.0'
export const API_VERSION_TWO = 'v2.0'
export const API_VERSION_THREE = 'v3'
export const REFERENCE_PARAMETER = 'referenceParameters'
export const RP_COLLECTIONS = 'rpCollections'
export const FEATURE_COLLECTIONS = 'featureCollections'
export const FEATURE_COLLECTION_DETAILS = 'featureCollectionsDetails'
export const SUPPORT_PARAMETER = 'supportParameters'
export const FEATURE = 'features'
export const FAST_FEATURES = 'fastFeatures'
export const DASH_LAYOUT = 'dash-layout'
export const FEATURE_SINGULAR = 'feature'
export const ADD_FEATURE = 'add-features'
export const FEATURE_TYPE = 'featureType'
export const FUNCTION = 'function'
export const QUERY = 'query'
export const FUNCTION_TYPE = 'functionType'
export const CONDITION_TYPE = 'conditionType'
export const OUTPUT_TYPE = 'outputType'
export const OUTPUT_BLOCK_TYPE = 'outputBlock'
export const RESOURCE_CIRCUITS = 'circuits'
export const RESOURCE_BUNDLES = 'bundles'
export const RESOURCE_BUNDLE_DETAILS = 'detailedBundles'
export const RESOURCE_CIRCUIT_DETAILS = 'detailedCircuits'
export const TRUCK = 'vehicles'
export const VEHICLES = 'vehicles'
export const FLEET = 'fleet'
export const ALERT = 'alert'
export const CTP = 'ctp'
export const PTO_TEMPLATES = 'pto-templates'
export const PTO_TEMPLATE = 'pto-template'
export const PTO_TEMPLATE_EDIT_NOTIFY = 'pto-template-edit-notify'
export const PTO_TEMPLATE_FRAGMENT = 'pto-template-fragment'
export const PTO_TEMPLATE_COMMIT = 'pto-template-commit'
export const SWITCHES_AND_GAUGES = 'switchesAndGauges'
export const COLLECTIONS = Object.freeze({
  [REFERENCE_PARAMETER]: REFERENCE_PARAMETER,
  [SUPPORT_PARAMETER]: SUPPORT_PARAMETER,
  [FEATURE]: FEATURE,
  [TRUCK]: TRUCK,
  [VEHICLES]: VEHICLES,
  [PTO_TEMPLATES]: PTO_TEMPLATES,
  [FEATURE_COLLECTIONS]: FEATURE_COLLECTIONS,
  [FAST_FEATURES]: FAST_FEATURES,
})
export const REFERENCE_PARAMETERS = 'reference-parameters'
export const SUPPORT_PARAMETERS = 'support-parameters'
export const COLLECTIONS_BY_URI = Object.freeze({
  [REFERENCE_PARAMETERS]: REFERENCE_PARAMETER,
  [SUPPORT_PARAMETERS]: SUPPORT_PARAMETER,
  [FEATURE]: FEATURE,
  [TRUCK]: TRUCK,
  [PTO_TEMPLATES]: PTO_TEMPLATES,
})

export const DAIMLER = 'Daimler'
export const CUSTOM = 'Custom'
export const PRIMARY_FILTER = 'PRIMARY_FILTER'
export const SECONDARY_FILTER = 'SECONDARY_FILTER'
export const SMART_PLEX = 'SMART_PLEX'
export const SMART_SWITCH = 'SMART_SWITCH'

export const COMMON_DELIMITER = '--'

export const APP = 'app'
export const COMPONENT = 'component'

export const SEARCH_PAGE_SIZE = 10
export const SEARCH_START_IDX = 1
export const SEARCH_TERM_MAX_LENGTH = 80

export const MIN_APP_VARIANT_FOR_SWITCH_INDICATOR = 0x118

export const CHK = 'CHK'

export const NODE_ENV_PRODUCTION = 'production'

/* date */
export const DATE_FORMAT = 'DD MMM YYYY'
export const DATE_FORMAT_COMMA = 'DD MMM, YYYY'
export const DATE_TIME_FORMAT = 'DD MMM YYYY, HH:mm'
export const DATE_TIME_API_FORMAT_TIMESTAMP = 'YYYY-MM-DDT00:00:00Z'

/* Note - Per Chad, the Max Value is the decimal version of hex #ffffff or the maximum number of 1's
that can be displayed in binary using 2 bits of data - which is the maximum amount of information
that can be passed to microcontrollers on the trucks. This value is both a max value for things
like timers and, in other contexts like mlogics, signifies 'unavailable', 'disabled' or 'no data'
 - aka, 'just fill it with 1's'. */
export const CHEC_MAX_VALUE = 65535
export const CHEC_MIN_VALUE = 0

export const stringMaxVal = String(CHEC_MAX_VALUE)
export const SWITCH = 'switch'

export const SMARTPLEX_MASTER_NUMBER = '35MP1'
export const PTO_MASTER_NUMBER = '885P1'
export const PTO_BASE_NUMBER = '01032'
export const PTO = 'PTO'
export const RP = 'RP'

// Notifications
export const NOTIFICATION_SUCCESS = 'NOTIFICATION_SUCCESS'
export const NOTIFICATION_ERROR = 'NOTIFICATION_ERROR'
export const NOTIFICATION_INFO = 'NOTIFICATION_INFO'
export const NOTIFICATION_PERSISTENT = 'NOTIFICATION_PERSISTENT'
export const NOTIFICATION_WARNING = 'NOTIFICATION_WARNING'

export const NOTIFICATION_DEFAULT_TIME = 3200
export const NOTIFICATION_DEFAULT_ERROR_TIME = 6000
export const NOTIFICATION_INLINE = 'inline'
export const NOTIFICATION_DROPDOWN = 'dropdown'
export const PENDING_FRAGMENTS = 'Pending Fragments'
export const ADD_COMPONENTS_WITHOUT_LOCATION_BANNER =
  'ADD_COMPONENTS_WITHOUT_LOCATION_BANNER'
export const SG_NOTES_ERROR_NOTIFY = 'SG_NOTES_ERROR_NOTIFY'
export const NO_DATA_AVAILABLE = 'NO_DATA_AVAILABLE'
export const NO_DIAGNOSTIC_VARIANT_AVAILABLE = 'NO_DIAGNOSTIC_VARIANT_AVAILABLE'
export const DTNA_CASE_MANAGEMENT_URL =
  'https://dtna.my.site.com/DTNAPartner/s/case-management'

// Alert Zones
export const GLOBAL_ZONE = 'Global'
export const REFERENCE_PARAMETER_ZONE = 'ReferenceParameter'
export const FEATURE_ZONE = 'Feature'
export const PTO_ZONE = 'Pto'
export const DASHBOARD_ZONE = 'Dashboard'
export const BHM_ECU_ZONE = 'BhmEcu'
export const CEEA_PLUS_ECU_ZONE = 'CeeaEcu'
export const PNEUMATIC_ZONE = 'Pneumatic'

// Modals
export const MODAL_TYPE_CONFIRMATION = 'MODAL_TYPE_CONFIRMATION'

// Support parameters - these are API dependent, don't change them unless the API spec changes
export const N_APP_DTC = 'N-APP-DTC'
export const N_APP_FAULT = 'N-APP-FAULT'
export const N_CAN = 'N-CAN'
export const N_FUEL_LEVEL_DATA = 'N-FUEL-LEVEL-DATA'
export const N_FUEL_LEVEL_CFG = 'N-FUEL-LEVEL-CFG'
export const N_TEMP_LEVEL_CFG = 'N-TEMP-LEVEL-CFG'
export const N_LIGHTMONITOR = 'N-LIGHTMONITOR'
export const N_MAP = 'N-MAP'
export const N_MLOGIC = 'N-MLOGIC'
export const N_MLOGIC2 = 'N-MLOGIC2'
export const N_PLC = 'N-PLC'
export const N_PREFLIGHT = 'N-PREFLIGHT'
export const N_PREFLIGHT2 = 'N-PREFLIGHT2'
export const N_PREFLIGHT3 = 'N-PREFLIGHT3'
export const N_PRIORITY = 'N-PRIORITY'
export const N_SLOTCOPY = 'N-SLOTCOPY'
export const N_SLOTINIT = 'N-SLOTINIT'
export const N_SSADDRESS = 'N-SSADDRESS'
export const N_STALKSWITCH = 'N-STALKSWITCH'
export const N_SUBCONFIG = 'N-SUBCFG'
export const N_SUBDATA = 'N-SUBDATA'
export const N_TEMP_LEVEL_DATA = 'N-TEMP-LEVEL-DATA'
export const N_TIMER = 'N-TIMER'
export const N_USER_DTC = 'N-USER-DTC'
export const N_USER_FAULT = 'N-USER-FAULT'
export const O_CAN = 'O-CAN'
export const O_FAULT = 'O-FAULT'
export const O_MAP = 'O-MAP'
export const O_MLOGIC = 'O-MLOGIC'
export const O_SLOTCOPY = 'O-SLOTCOPY'
export const O_SLOTINIT = 'O-SLOTINIT'
export const O_TIMER = 'O-TIMER'
export const S_CANSLOTS = 'S-CANSLOTS'
export const S_MAPSLOTS = 'S-MAPSLOTS'
export const S_MEMORY = 'S-MEMORY'
export const S_TIMERSLOTS = 'S-TIMERSLOTS'
export const S_MLOGICSLOTS = 'S-MLOGICSLOTS'
export const S_SLOTINITSLOTS = 'S-SLOTINITSLOTS'
export const N_POWERDOWN = 'N-POWERDOWN'
export const N_Modal = 'N-Modal'
export const N_VIN = 'N-VIN'
export const N_VERSION = 'N-VERSION'
export const N_CANSIZE = 'N-CANSIZE'
export const N_RPSIZE = 'N-RPSIZE'
export const N_RPLOC = 'N-RPLOC'
export const N_EFFORT_CONTROL_DATA = 'N-EFFORT-CONTROL-DATA'
export const N_ANALOG_SENSOR_8BIT_DATA = 'N-ANALOG-SENSOR-8BIT-DATA'
export const N_ANALOG_SENSOR_16BIT_DATA = 'N-ANALOG-SENSOR-16BIT-DATA'
export const N_ANALOG_SENSOR_32BIT_DATA = 'N-ANALOG-SENSOR-32BIT-DATA'
export const N_EFFORT_CONTROL_CFG = 'N-EFFORT-CONTROL-CFG'
export const N_ANALOG_SENSOR_8BIT_CFG = 'N-ANALOG-SENSOR-8BIT-CFG'
export const N_ANALOG_SENSOR_16BIT_CFG = 'N-ANALOG-SENSOR-16BIT-CFG'
export const N_ANALOG_SENSOR_32BIT_CFG = 'N-ANALOG-SENSOR-32BIT-CFG'
// TODO - PLEASE UPDATE THIS ARRAY AS NEW TYPES ARE ADDED!

export const SMARTPLEX_INPUT = 'smartplex_input'
export const SMARTPLEX_OUTPUT = 'smartplex_output'
export const SMART_SWITCH_GROUP = 'smart_switch'
export const BASE_TYPE = 'base_type'
export const LOGIC_SET = 'logicSet'
export const NATIVE_SIGNALS = 'nativeSignals'
export const SWITCHES = 'switches'
export const INTERFACE_CONNECTOR = 'interfaceConnector'
export const MODULE_TYPE_FILTER = 'moduleType'
export const FIRST_DROPDOWN = 'first_dropdown'
export const SECOND_DROPDOWN = 'second_dropdown'
export const THIRD_DROPDOWN = 'third_dropdown'
export const FOURTH_DROPDOWN = 'fourth_dropdown'
export const FIFTH_DROPDOWN = 'fifth_dropdown'
export const NATIVE_INPUTS = 'nativeInputs'
export const NATIVE_OUTPUTS = 'nativeOutputs'
export const USER = 'user'
export const SP_TYPE = 'SP_TYPE'
export const B2_TYPE = 'B2'
export const M2_TYPE = 'M2'
export const RV_TYPE = 'RV'
export const M2_SD_TYPE = 'M2/SD'
export const B2_NMAP_ROWID = 'base_type_B2_sp_type_N-MAP_rowId'
export const B2_NMAP_DESC = 'base_type_B2_sp_type_N-MAP_description'
export const M2_NMAP_ROWID = 'base_type_M2_sp_type_N-MAP_rowId'
export const M2_NMAP_DESC = 'base_type_M2_sp_type_N-MAP_description'
export const RV_NMAP_ROWID = 'base_type_RV_sp_type_N-MAP_rowId'
export const RV_NMAP_DESC = 'base_type_RV_sp_type_N-MAP_description'
export const DESC_SCHEMA =
  'reference-parameter.contains.support-parameter-description'
export const ROWID_SCHEMA =
  'reference-parameter.contains.support-parameter-rowId'
export const PGN_SCHEMA = 'reference-parameter.contains.support-parameter-pgn'
export const SWITCHID_SCHEMA =
  'reference-parameter.contains.support-parameter-switchId'
export const FEATURE_SWITCHID_SCHEMA = 'features.contains.switchId'
export const MODULE_TYPE_SCHEMA = 'feature.equals.moduleType'
export const INPUT_TYPE_SCHEMA = 'feature.contains.input-type'
export const INPUT_PIN_SCHEMA = 'feature.contains.input-pin'
export const OUPUT_TYPE_SCHEMA = 'feature.contains.output-type'
export const OUPUT_PIN_SCHEMA = 'feature.contains.output-pin'
export const INTERFACE_PIN_TYPE_SCHEMA = 'feature.contains.interface-pin-type'
export const INTERFACE_PIN_NUM_DESC_SCHEMA =
  'feature.contains.interface-pin-number'
export const SWITCH_ID = 'switch-id'
export const INPUT_PIN = 'input'
export const OUTPUT_PIN = 'output'
export const INTERFACE_CONN_TYPE_FILTER = 'interfaceConnector'
export const filterSchemaForAddRemoveFeatures = Object.freeze({
  [SWITCH_ID]: FEATURE_SWITCHID_SCHEMA,
  [INPUT_PIN]: INPUT_PIN_SCHEMA,
  [OUTPUT_PIN]: OUPUT_PIN_SCHEMA,
  [MODULE_TYPE_FILTER]: MODULE_TYPE_SCHEMA,
  [INTERFACE_CONN_TYPE_FILTER]: INTERFACE_PIN_NUM_DESC_SCHEMA,
})

export const ADVANCED_FILTER_TYPES = Object.freeze({
  'Smartplex Input': SMART_PLEX,
  'Smartplex Output': SMART_PLEX,
  'Smart Switch': SMART_SWITCH,
  'O-MLogic': O_MLOGIC,
  'N-MLogic': N_MLOGIC,
  'N-MLogic2': N_MLOGIC2,
  'O-Slotcopy': O_SLOTCOPY,
  'N-Slotcopy': N_SLOTCOPY,
  'O-Timer': O_TIMER,
  'N-Timer': N_TIMER,
  'O-CAN': O_CAN,
  'N-CAN': N_CAN,
  'N-PLC': N_PLC,
  'O-MAP': O_MAP,
  'N-MAP': N_MAP,
})

export const SUPPORT_PARAMETER_TYPES = [
  N_APP_DTC,
  N_APP_FAULT,
  N_CAN,
  N_FUEL_LEVEL_DATA,
  N_FUEL_LEVEL_CFG,
  N_LIGHTMONITOR,
  N_MAP,
  N_MLOGIC,
  N_MLOGIC2,
  N_PLC,
  N_PREFLIGHT,
  N_PREFLIGHT2,
  N_PREFLIGHT3,
  N_PRIORITY,
  N_SLOTCOPY,
  N_SLOTINIT,
  N_SSADDRESS,
  N_STALKSWITCH,
  N_SUBCONFIG,
  N_SUBDATA,
  N_TEMP_LEVEL_DATA,
  N_TEMP_LEVEL_CFG,
  N_TIMER,
  N_USER_DTC,
  N_USER_FAULT,
  O_CAN,
  O_MAP,
  O_FAULT,
  O_MLOGIC,
  O_SLOTCOPY,
  O_SLOTINIT,
  O_TIMER,
  S_CANSLOTS,
  S_MAPSLOTS,
  S_MEMORY,
  S_TIMERSLOTS,
  S_MLOGICSLOTS,
  S_SLOTINITSLOTS,
  N_POWERDOWN,
  N_Modal,
  N_VIN,
  N_VERSION,
  N_CANSIZE,
  N_RPSIZE,
  N_RPLOC,
  N_EFFORT_CONTROL_DATA,
  N_ANALOG_SENSOR_8BIT_DATA,
  N_ANALOG_SENSOR_16BIT_DATA,
  N_ANALOG_SENSOR_32BIT_DATA,
  N_EFFORT_CONTROL_CFG,
  N_ANALOG_SENSOR_8BIT_CFG,
  N_ANALOG_SENSOR_16BIT_CFG,
  N_ANALOG_SENSOR_32BIT_CFG,
]
export const CURRENTLY_SEARCHABLE_SP_TYPES = [
  N_CAN,
  N_MAP,
  N_MLOGIC,
  N_MLOGIC2,
  N_PLC,
  N_SLOTCOPY,
  N_TIMER,
  O_CAN,
  O_MAP,
  O_MLOGIC,
  O_SLOTCOPY,
  O_TIMER,
]
export const NATIVE_SP_TYPES = [
  N_CAN,
  N_MAP,
  N_MLOGIC,
  N_MLOGIC2,
  N_PLC,
  N_SLOTCOPY,
  N_TIMER,
]
export const MLOGIC_TYPES = [N_MLOGIC, N_MLOGIC2, O_MLOGIC]
export const SP_MAP_TYPES = [N_MAP, O_MAP]
export const PLC_ENABLE_SHORT_VALUE = '65534'

export const SWITCH_POSITION_UPPER = 'Switch Position, Upper'
export const SWITCH_POSITION_LOWER = 'Switch Position, Lower'
export const SWITCH_POSITION_INDICATOR = 'Switch Position, Indicator'
export const SWITCH_POSITION_MIDDLE = 'Switch Position, Middle'
export const BHM_DIGITAL_IN = 'BHM Digital Input'
export const BHM_DIGITAL_OUT = 'BHM Digital Output'
export const BHM_ANALOG_IN = 'BHM Analog Input'
export const BHM_FREQ_IN = 'BHM Frequency Input'
export const BHM_PWM_OUT = 'BHM PWM Output'
export const BHM_MOTOR_OUT = 'BHM Motor Output'
export const DMA = 'Direct Memory Access'
export const CAN_MESSAGE = 'CAN Message'
export const CIRCUIT = 'Circuit'
export const DISABLED = 'Disabled'
export const ALL = 'All'
export const ACTIVE = 'Active'
export const TEST = 'Test'
export const VERIFIED = 'Verified'
export const OBSOLETE = 'Obsolete'
export const NEW = 'New'
export const RETURNED = 'Returned'
export const DESIGN = 'Design'
export const EDITABLE_STATUSES = [NEW, RETURNED]
export const NON_TEST_STATUSES = [NEW, RETURNED, ACTIVE, OBSOLETE]
export const NON_EDITABLE_STATUSES = [ACTIVE, TEST, VERIFIED, OBSOLETE]
export const VALID_STATUSES = [ACTIVE, TEST, VERIFIED]
export const CONFIRM_ACTIVATE = 'Confirm activate'

export const N_MAP_TYPES = [
  SWITCH_POSITION_UPPER,
  SWITCH_POSITION_LOWER,
  SWITCH_POSITION_INDICATOR,
  SWITCH_POSITION_MIDDLE,
  BHM_DIGITAL_IN,
  BHM_DIGITAL_OUT,
  BHM_ANALOG_IN,
  BHM_FREQ_IN,
  BHM_PWM_OUT,
  BHM_MOTOR_OUT,
  DMA,
  CAN_MESSAGE,
]
export const O_MAP_TYPES = [
  SWITCH_POSITION_UPPER,
  SWITCH_POSITION_LOWER,
  SWITCH_POSITION_INDICATOR,
  CIRCUIT,
  CAN_MESSAGE,
]

export const SLOT_EDIT_NONE = 'none'
export const SLOT_EDIT_OPEN = 'open'
export const SLOT_EDIT_SHORT = 'closed'
export const SLOT_EDIT_INPUT = 'input'
export const SLOT_EDIT_OUTPUT = 'output'
export const SLOT_EDIT_DISPLAY_MODES = [
  SLOT_EDIT_NONE,
  SLOT_EDIT_OPEN,
  SLOT_EDIT_SHORT,
  SLOT_EDIT_INPUT,
  SLOT_EDIT_OUTPUT,
]

export const LOGICAL_SLOT = 'logical_slot'

export const WINDOW = 'WINDOW'
export const TEXT_WINDOW = 'TEXT_WINDOW'
export const HTML_WINDOW = 'HTML_WINDOW'
export const WINDOW_OPEN = 'WINDOW_OPEN'
export const WINDOW_MINIMIZED = 'WINDOW_MINIMIZED'

export const AFFINITY_COLOR_PINK = 'pink'
export const AFFINITY_COLOR_VIOLET = 'violet'
export const AFFINITY_COLOR_GREEN = 'green'
export const AFFINITY_COLOR_ORANGE = 'orange'
export const AFFINITY_CLASS_NAME_PINK = 'affinity-pink'
export const AFFINITY_CLASS_NAME_VIOLET = 'affinity-violet'
export const AFFINITY_CLASS_NAME_GREEN = 'affinity-green'
export const AFFINITY_CLASS_NAME_ORANGE = 'affinity-orange'
export const MAX_SELECTED_AFFINITIES = 4

export const RP_SERVICE_DESCRIPTION_MAX_LENGTH = 80
export const RP_ITEM_DESCRIPTION_MAX_LENGTH = 80
export const FUNCTION_DESCRIPTION_MAX_LENGTH = 80

export const STAGED_RP_MAX = 10
export const MAX_SLOT_NAME_LEN = 22
export const MAX_NOTE_LENGTH = 1000

export const ADDRESS = 'address'
export const PGN = 'pgn'

export const RXTX = 'rx_tx'
export const ALLOW_EDIT_MESSAGE_ID = '61184'

export const COMPLEX = 'complex'
export const SIMPLE = 'simple'
export const CARRY_OUTPUT = 'carry-output'
export const CARRY_LOGIC_SET = 'carry-logicset'
export const CARRY_TIMER = 'carry-timer'
export const SELF_REFERENCE = 'self-reference'
export const TIMER = 'timer'
export const DIGITAL_INPUT = 'digitalInput'
export const DIGITAL_OUTPUT = 'digitalOutput'
export const CAN_OUTPUT = 'canOutput'
export const ANALOG_INPUT = 'analogInput'
export const NATIVE_INPUT = 'nativeInput'
export const SWITCH_INPUT = 'switchInput'
export const UNSIGNED_16_BIT_INT = 'Uint16'
export const SIXTEEN_BIT_OUTPUT = 'sixteenBitOutput'
export const CAN_INPUT = 'can'
export const SIMPLE_QUERY = 'Simple Query'
export const CAN_EVENT = 'CAN Event'
export const REFERENCED = 'referenced'
export const CARRY = 'carry'

export const TOGGLE = 'toggle'

export const DIGITAL = 'DIGITAL'
export const ANALOG = 'ANALOG'
export const NATIVE = 'NATIVE'

export const DIGITAL_CONDITION = `${SIMPLE}_${DIGITAL_INPUT}`
export const ANALOG_CONDITION = `${SIMPLE}_${ANALOG_INPUT}`
export const NATIVE_CONDITION = `${SIMPLE}_${NATIVE_INPUT}`
export const CAN_CONDITION = `${SIMPLE}_${CAN_INPUT}`
export const SWITCH_CONDITION = `${SIMPLE}_${SWITCH_INPUT}`

export const PIN = 'PIN'
export const SERVICE = 'SERVICE'
export const CAN = 'CAN'

export const DO_PIN_NON_PWM = 'DO_PIN_NON_PWM'
export const DO_PIN_PWM = 'DO_PIN_PWM'
export const NATIVE_BOOL = 'NATIVE_BOOL'
export const NATIVE_NON_BOOL = 'NATIVE_NON_BOOL'
export const CAN_TWO_BIT = 'CAN_TWO_BIT'
export const CAN_SIXTEEN_BIT = 'CAN_SIXTEEN_BIT'
export const CAN_OTHER_BIT = 'CAN_OTHER_BIT'

export const SIMPLE_MAP = Object.freeze({
  [DIGITAL_CONDITION]: DIGITAL_INPUT,
  [ANALOG_CONDITION]: ANALOG_INPUT,
  [NATIVE_CONDITION]: NATIVE_INPUT,
  [CAN_CONDITION]: CAN_INPUT,
})

export const CONDITION_MAP = Object.freeze({
  [DIGITAL_INPUT]: DIGITAL_CONDITION,
  [ANALOG_INPUT]: ANALOG_CONDITION,
  [NATIVE_INPUT]: NATIVE_CONDITION,
  [CAN_INPUT]: CAN_CONDITION,
  [SWITCH_CONDITION]: SWITCH_CONDITION,
})

export const CONDITION_SUB_TYPES = Object.freeze(
  new Set([NATIVE_INPUT, ANALOG_INPUT, DIGITAL_INPUT, CAN_INPUT])
)

// Feature
export const NO_EDGE = 'NoEdge'
export const BOTH_EDGES = 'BothEdges'
export const FALLING_EDGE = 'FallingEdge'
export const RISING_EDGE = 'RisingEdge'
export const QUERY_EDGE_VALUES = [
  NO_EDGE,
  BOTH_EDGES,
  FALLING_EDGE,
  RISING_EDGE,
]
export const QUERY_OPERATORS = ['or', 'and', 'xor', 'toggle']
export const RUNG_A = 'queryA'
export const RUNG_B = 'queryB'
export const RUNG_C = 'queryC'
export const RUNG_D = 'queryD'
export const RUNG_ENABLE = 'enable'
export const RUNG_RESET = 'reset'
export const LOGICSET_RUNG_NAMES = Object.freeze([
  RUNG_A,
  RUNG_B,
  RUNG_C,
  RUNG_D,
])
export const TIMER_RUNG_NAMES = Object.freeze(['enable', 'reset'])
export const LOGICSET_OR_TIMER_RUNG_NAMES = Object.freeze(
  ...LOGICSET_RUNG_NAMES,
  ...TIMER_RUNG_NAMES
)
export const SIMPLE_RUNG_NAMES = Object.freeze([
  DIGITAL_CONDITION,
  ANALOG_CONDITION,
  NATIVE_CONDITION,
])
export const SINGLE_CONDITION_NAMES = Object.freeze([
  ...SIMPLE_RUNG_NAMES,
  CAN_CONDITION,
])
export const NOT_SINGLE_CONDITION_NAMES = Object.freeze([TIMER, COMPLEX])
export const ALL_RUNG_NAMES = Object.freeze([
  ...LOGICSET_RUNG_NAMES,
  ...TIMER_RUNG_NAMES,
  ...SIMPLE_RUNG_NAMES,
])
export const CONDITION_NAMES = Object.freeze({
  RUNG_A,
  RUNG_B,
  RUNG_C,
  RUNG_D,
  RUNG_ENABLE,
  RUNG_RESET,
})
export const RUNG_POSITIONS = Object.freeze({
  [RUNG_A]: 0,
  [RUNG_B]: 1,
  [RUNG_C]: 2,
  [RUNG_D]: 3,
  [RUNG_ENABLE]: 2,
  [RUNG_RESET]: 3,
})

// TODO: move to constants/ui
export const BOOLEAN = 'boolean'
export const STATE = 'state'
export const RANGE = 'range'
export const UNDEFINED = 'undefined'

export const CARRY_TO = 'carry-to'

// export const SINGLE_QUERY_TYPES = Object.freeze(new Set([SIMPLE, DIGITAL_INPUT, ANALOG_INPUT, CAN_INPUT]))
export const QUERY_BOX_TYPES = Object.freeze(new Set([COMPLEX, TIMER]))
export const INPUT_QUERY_TYPES = Object.freeze(new Set([COMPLEX, TIMER]))
export const QUERY_TYPES_WITH_EVALUATION = Object.freeze(
  new Set([CARRY_LOGIC_SET, SELF_REFERENCE])
)
export const OUTPUT_QUERY_TYPES_WITHOUT_EVALUATION = Object.freeze(
  new Set([SIMPLE, CAN_INPUT, TIMER])
)
export const RUNG_TYPES_WITH_CARRY_SYMBOL = Object.freeze(
  new Set([CARRY_LOGIC_SET, CARRY_TIMER, SELF_REFERENCE])
)
export const RUNG_TYPES_WITH_HYSTERESIS = Object.freeze(
  new Set([ANALOG_INPUT, TIMER, CARRY_TIMER, SIMPLE, CAN_INPUT, NATIVE_INPUT])
)
export const SUBTYPES_WITH_HYSTERESIS = Object.freeze(
  new Set([ANALOG_INPUT, CAN_INPUT, NATIVE_INPUT, CARRY])
)
export const CARRY_CONNECTOR_TYPES = Object.freeze(
  new Set([CARRY_LOGIC_SET, CARRY_TIMER])
)
export const CARRY_TYPES = Object.freeze(
  new Set([CARRY_LOGIC_SET, CARRY_TIMER, SELF_REFERENCE, REFERENCED, CARRY])
)
export const NON_NATIVE_SIGNAL_TYPES = Object.freeze(
  new Set([DIGITAL_INPUT, ANALOG_INPUT, CAN_INPUT])
)
export const TYPES_WITHOUT_ORIGIN_PIPE = Object.freeze(
  new Set([
    ...RUNG_TYPES_WITH_CARRY_SYMBOL,
    ...QUERY_TYPES_WITH_EVALUATION,
    ...QUERY_BOX_TYPES,
  ])
)
export const SINGLE_CONDITON_NODES = Object.freeze(new Set([SIMPLE, CAN_INPUT]))
export const SINGLE_CONDITION_TYPES = Object.freeze(
  new Set([NATIVE_INPUT, DIGITAL_INPUT, ANALOG_INPUT, SWITCH_INPUT])
)

export const CONFIGURABLE_INPUT_TYPES = Object.freeze(
  new Set([DIGITAL_INPUT, ANALOG_INPUT])
)
export const TRANSLATION_TYPES = Object.freeze(new Set([BOOLEAN, STATE]))
export const DYNAMIC_INPUT_TYPES = Object.freeze(
  new Set([BOOLEAN, STATE, RANGE])
)
export const CAN_INPUT_ALLOWABLE_NUM_BITS = Object.freeze([1, 2, 4, 6, 8, 16])
export const ALLOWED_NUM_BITS_INPUT_TO_16_BIT_CAN_OUTPUT = Object.freeze([
  4, 6, 8, 16,
])

export const CAN_INPUT_ALLOWABLE_NUM_BITS_NATIVE_OUTPUT = Object.freeze([
  4, 6, 8, 16,
])
export const ALLOWED_NUM_BITS_INPUT_TO_NATIVE_OUTPUT = Object.freeze([1, 2])

export const VEHICLE_SUBTYPES = Object.freeze({
  M2: 'M2',
  S2: 'S2',
  BUS: 'BUS',
  RV: 'RV',
  CHECPLUS: 'CHECPLUS',
})

// possible default service date when no service records present
export const FALLBACK_SERVICE_DATE = '0001-01-01T00:00:00'
export const ECP = 'ecp'
export const ECU = 'ecu'
const EXM1 = 'EXM1'
const EXM2 = 'EXM2'
const EXM3 = 'EXM3'
export const BHM = 'BHM'
export const CHM = 'CHM'
const DASH_O = 'DASH_O'
export const SMARTPLEX = 'SmartPlex'
export const SHM = 'SHM'
export const BHM_C7C_PIN = 'BHM/C7C'

export const EXM_BASE = 'EXM'
export const M2_EXPANSION_MODULES = Object.freeze({
  EXM1,
  EXM2,
  EXM3,
})
export const M2_REAL_MODULES = Object.freeze({
  BHM,
  CHM,
  DASH_O,
})
export const M2_MISC_MODULES = Object.freeze({
  SMARTPLEX,
  SHM,
})

export const M2_MODULES = Object.freeze({
  ...M2_REAL_MODULES,
  ...M2_EXPANSION_MODULES,
  ...M2_MISC_MODULES,
})

export const ADD_XMC = 'addXmc'

export const XMC = 'XMC'
export const XMC1 = 'XMC1'
export const XMC2 = 'XMC2'
export const XMC3 = 'XMC3'
export const XMC4 = 'XMC4'
export const XMC5 = 'XMC5'
export const XMC6 = 'XMC6'
export const XMC7 = 'XMC7'
export const XMC8 = 'XMC8'
export const XMC9 = 'XMC9'
export const ASAM = 'ASAM'

export const FEATURE_MODULE_NAMES_WITH_HARNESSES = Object.freeze([
  ASAM,
  XMC1,
  XMC2,
])

export const DEFAULT_OUTPUT_BITS = Object.freeze({
  [ASAM]: 16,
  [XMC1]: 2,
  [XMC2]: 2,
  [XMC3]: 2,
  [XMC4]: 2,
  [XMC5]: 2,
  [XMC6]: 2,
})
const INTERFACE = 'interface'
export const CHECPLUS_MODULE_TYPES = Object.freeze({
  XMC,
  ASAM,
})
export const CHECPLUS_MODULE_NAMES = Object.freeze({
  ASAM,
  XMC1,
  XMC2,
  XMC3,
  XMC4,
  XMC5,
  XMC6,
  XMC7,
  XMC8,
})
export const BUS_MODULES = Object.freeze([XMC3, XMC4, XMC5, XMC6, XMC7, XMC8])
export const NON_BUS_MODULES = Object.freeze([ASAM, XMC1, XMC2, XMC3, XMC4])
export const VECHICLE_TYPE_BUS = 'BUS'
export const MODULE_TYPE = Object.freeze({
  [CHECPLUS_MODULE_NAMES.ASAM]: CHECPLUS_MODULE_TYPES.ASAM,
  [CHECPLUS_MODULE_NAMES.XMC1]: CHECPLUS_MODULE_TYPES.XMC,
  [CHECPLUS_MODULE_NAMES.XMC2]: CHECPLUS_MODULE_TYPES.XMC,
  [CHECPLUS_MODULE_NAMES.XMC3]: CHECPLUS_MODULE_TYPES.XMC,
  [CHECPLUS_MODULE_NAMES.XMC4]: CHECPLUS_MODULE_TYPES.XMC,
  [CHECPLUS_MODULE_NAMES.XMC5]: CHECPLUS_MODULE_TYPES.XMC,
  [CHECPLUS_MODULE_NAMES.XMC6]: CHECPLUS_MODULE_TYPES.XMC,
})
export const XMC_MODULES = Object.freeze([
  XMC1,
  XMC2,
  XMC3,
  XMC4,
  XMC5,
  XMC6,
  XMC7,
  XMC8,
])
export const CHECPLUS_MOD_WITH_FEATURES = Object.freeze([
  ASAM,
  XMC1,
  XMC2,
  XMC3,
  XMC4,
  XMC5,
  XMC6,
  XMC7,
  XMC8,
])
const INTERFACE_MODULE_NAMES = Object.freeze({
  INTERFACE,
})

export const ALL_MODULE_NAMES = Object.freeze({
  ...M2_MODULES,
  ...CHECPLUS_MODULE_NAMES,
  ...INTERFACE_MODULE_NAMES,
})

export const MAX_LOGICSETS_PER_XMC = 40
export const MAX_LOGICSETS_PER_ASAM = 20
export const MAX_TIMERS_PER_XMC = 20

export const MAX_TIMERS_PER_ASAM = 10

export const MAX_MODULE_COUNTS = Object.freeze({
  [XMC]: {
    MAX_COMPLEX_QUERY_COUNT: MAX_LOGICSETS_PER_XMC,
    MAX_TIMER_QUERY_COUNT: MAX_TIMERS_PER_XMC,
  },
  [ASAM]: {
    MAX_COMPLEX_QUERY_COUNT: MAX_LOGICSETS_PER_ASAM,
    MAX_TIMER_QUERY_COUNT: MAX_TIMERS_PER_ASAM,
  },
})
export const INITIAL = 'initial'
export const ECU_BUTTON_MODULES = Object.freeze([
  ASAM,
  XMC1,
  XMC2,
  XMC3,
  XMC4,
  XMC5,
  XMC6,
  INTERFACE,
  BHM,
  CHM,
  DASH_O,
  SMARTPLEX,
  EXM1,
  EXM2,
  EXM3,
])

export const EXM_SIZE = Object.freeze({
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large',
})

export const EXM_ORDINAL = Object.freeze({
  SMALL: 1,
  MEDIUM: 2,
  LARGE: 3,
})

export const ALL_VEHICLE_PRIMARY_MODULES = new Set([
  M2_REAL_MODULES.BHM,
  M2_REAL_MODULES.DASH_O,
  ASAM,
])

export const ALL_VEHICLE_PRIMARY_MODULES_TRANSLATED = Object.freeze({
  [M2_REAL_MODULES.BHM]: M2_REAL_MODULES.BHM,
  [M2_REAL_MODULES.DASH_O]: 'RVM',
  [ASAM]: ASAM,
})

export const VEHICLE_TYPE_M2 = 'CHEC2'
export const VEHICLE_TYPE_CHEC_PLUS = 'CHECP'

export const VEHICLE_TYPE_MODULES = Object.freeze({
  [VEHICLE_TYPE_M2]: M2_MODULES,
  [VEHICLE_TYPE_CHEC_PLUS]: CHECPLUS_MODULE_NAMES,
})

export const ALIASED_MODULES = Object.freeze({
  ...M2_EXPANSION_MODULES,
  [M2_MODULES.CHM]: M2_MODULES.CHM,
})

// Possible long-term flaw: assumes module names are globally unique and never
// a substring of another, across all vehicle types.  So prefer
// *_MODULES lists.  Note getModuleName() depends on this globality.
export const MODULES = Object.freeze(
  Object.assign({}, ...Object.values(VEHICLE_TYPE_MODULES), {
    INTERFACE,
  })
)

// XXX test cases!
// Returns null if invalid index.
export const getEnumValue = (enumeration, index) => {
  // TBD: if (Array.isArray(enum)... else object...
  if (index < 0 || index > enumeration.length - 1) return null
  return enumeration[index]
}
// Returns -1 if invalid value.
export const getEnumIndex = (enumeration, value) => enumeration.indexOf(value)

export const CEEAVehicleTabs = Object.freeze({
  pneumatics: 'pneumatics',
  powerTakeOff: 'pto',
})
export const SharedVehicleTabs = Object.freeze({
  vehicle: 'vehicle',
  ecus: 'ecus',
  switchandgauge: 'switchandgauge',
  history: 'history',
  summary: 'summary',
})

export const AH = 'AH'
export const AL = 'AL'
export const ACTIVE_HIGH = 'ActiveHigh'
export const ACTIVE_LOW = 'ActiveLow'
export const HIGH_SIDE = 'High Side'
export const LOW_SIDE = 'Low Side'
export const PWM = 'PWM'
export const DUTY_CYCLE = 'Duty Cycle'
export const VOLT_0_18K5 = 'Volt_0_18k5'
export const VOLT_0_6 = 'Volt_0_6'
export const RES_0_100k = 'Res_0_100k'
export const RES_0_500 = 'Res_0_500'
export const VOLT_0_16_rel = 'Volt_0_16_rel'
export const INPUT_CONFIG_RANGES = Object.freeze({
  [DIGITAL_INPUT]: Object.freeze([ACTIVE_HIGH, ACTIVE_LOW]),
  [ANALOG_INPUT]: Object.freeze([
    RES_0_500,
    RES_0_100k,
    VOLT_0_6,
    VOLT_0_18K5,
    VOLT_0_16_rel,
  ]),
})
export const NOT_CONFIGURED = 'NotConfigured'
export const M0 = 'RestartAfter0'
export const M1 = 'RestartWithReset'
export const M2 = 'RestartWhenEnableLost'

// XXX Never use a user-facing string as an internal constant!
// Add a type field to this rpOutputs object in MLogicEditor.jsx
export const CARRY_ONLY = 'CARRY ONLY'

// External Links
export const SERVICE_LINK = 'https://secure.freightliner.com/servicelink/'

// System Wide
export const CHEC_PATHNAME_BASE = '/chec'
export const CHEC_PROD_HOST = 'chec-dtna.e.corpintra.net'
export const CHEC_PROD_HOST_EXTERNAL = 'chec-dtna.prd.freightliner.com'
export const CHEC_QA_HOST = 'chec-dtna-test.app.corpintra.net'
export const CHEC_QA_HOST_EXTERNAL = 'chec-dtna-test.qa.freightliner.com'
export const CHEC_DEV_HOST = 'chec-dtna-dev.app.corpintra.net'
export const SITEMINDER_PROD_LOGIN =
  'https://login.e.corpintra.net/internal/login'
export const SITEMINDER_QA_LOGIN =
  'https://cd-appstest.e.corpintra.net/internal/login'

// Google Analytics
export const GA_QA_EXTERNAL = 'UA-48402755-18'
export const GA_QA_INTERNAL = 'UA-48402755-22'
export const GA_PROD_EXTERNAL = 'UA-48402755-23'
export const GA_PROD_INTERNAL = 'UA-48402755-24'
export const GA_IDS_BY_HOSTNAME = Object.freeze({
  [CHEC_PROD_HOST]: GA_PROD_INTERNAL,
  [CHEC_PROD_HOST_EXTERNAL]: GA_PROD_EXTERNAL,
  [CHEC_QA_HOST]: GA_QA_INTERNAL,
  [CHEC_QA_HOST_EXTERNAL]: GA_QA_EXTERNAL,
})

export const GTM_DEV_INTERNAL = 'G-CC54SPDEPD'
export const GTM_QA_EXTERNAL = 'G-9KSQZSCW8B'
export const GTM_QA_INTERNAL = 'G-J4PMCP95MC'
export const GTM_PROD_INTERNAL = 'G-L3DYZEB4QQ'
export const GTM_PROD_EXTERNAL = 'G-BMSQWG0W51'
export const GTM_IDS_BY_HOSTNAME = Object.freeze({
  [CHEC_PROD_HOST]: GTM_PROD_INTERNAL,
  [CHEC_PROD_HOST_EXTERNAL]: GTM_PROD_EXTERNAL,
  [CHEC_QA_HOST]: GTM_QA_INTERNAL,
  [CHEC_QA_HOST_EXTERNAL]: GTM_QA_EXTERNAL,
  [CHEC_DEV_HOST]: GTM_DEV_INTERNAL,
  localhost: GTM_DEV_INTERNAL,
})

// Host names
export const LOCAL = 'localhost'
export const PROD_EXTERNAL = 'chec-dtna.prd.freightliner.com'
export const QA_EXTERNAL = 'chec-dtna-test.qa.freightliner.com'
export const DEV_EXTERNAL = 'chec-dtna-dev.dev.freightliner.com'
export const PROD_INTERNAL = 'chec-dtna.app.corpintra.net'
export const QA_INTERNAL = 'chec-dtna-test.app.corpintra.net'
export const DEV_INTERNAL = 'chec-dtna-dev.app.corpintra.net'
export const UAT = 'chec-dtna-stg.qa.freightliner.com'
export const AKS_TEST_VIP = 'dtna-chec-aks-uat-test.us164.corpintra.net'
export const PROD_EXTERNAL_AKS = 'chec-dtna.na.daimlertruck.com'
export const QA_EXTERNAL_AKS = 'chec-dtna-test.na.daimlertruck.com'
export const STG_EXTERNAL_AKS = 'chec-dtna-stg.na.daimlertruck.com'
export const PROD_INTERNAL_AKS = 'chec-dtna.cloud.tbintra.net'
export const QA_INTERNAL_AKS = 'chec-dtna-test.cloud.tbintra.net'
export const STG_INTERNAL_AKS = 'chec-dtna-stg.cloud.tbintra.net'
export const DEV_INTERNAL_AKS = 'chec-dtna-uat.cloud.tbintra.net'
export const QA_PLANT_AKS = 'chec-plant-test.cloud.tbintra.net'
export const PROD_PLANT_AKS = 'chec-plant.cloud.tbintra.net'
// VIT platform host names (internal hub001 - dev/qa only)
export const DEV_INTERNAL_VIT_HUB =
  'chec-dev.vehicleit.210-az-np-hub001.cloud.tbintra.net'
export const QA_INTERNAL_VIT_HUB =
  'chec-qa.vehicleit.210-az-np-hub001.cloud.tbintra.net'
// VIT platform host names (internal)
export const DEV_INTERNAL_VIT = 'chec.vit-dev.cloud.tbintra.net'
export const QA_INTERNAL_VIT = 'chec.vit-qa.cloud.tbintra.net'
export const STG_INTERNAL_VIT = 'chec.vit-prod-001.cloud.tbintra.net'
export const PROD_INTERNAL_VIT = 'chec.vit.cloud.tbintra.net'
// VIT platform host names (external)
export const DEV_EXTERNAL_VIT = 'chec.vit-dev.daimlertruck.com'
export const QA_EXTERNAL_VIT = 'chec.vit-qa.daimlertruck.com'
export const STG_EXTERNAL_VIT = 'chec.vit-stg.daimlertruck.com'
export const PROD_EXTERNAL_VIT = 'chec.vit.daimlertruck.com'
// VIT platform host names (plant)
export const DEV_PLANT_VIT = 'chec-plant.vit-dev.cloud.tbintra.net'
export const QA_PLANT_VIT = 'chec-plant.vit-qa.cloud.tbintra.net'
export const STG_PLANT_VIT = 'chec-plant.vit-prod-001.cloud.tbintra.net'
export const PROD_PLANT_VIT = 'chec-plant.vit.cloud.tbintra.net'
export const SANDBOX = 'dtnaaiassw004'

// for circuit utils Fn
export const AS_BUILT_WITH_DASH = 'As-Built'
export const AS_BUILT = 'AS_BUILT'
export const NONEXISTANT = 'NONEXISTANT'
export const AVAILABLE = 'AVAILABLE'
export const ASSIGNED = 'ASSIGNED'
export const FIXED = 'FIXED'
export const UNAVAILABLE = 'UNAVAILABLE'
export const RESTRICTED = 'RESTRICTED'

export const restrictedModules = [ASAM, XMC1, XMC2]

// for checking pin movability
export const INPUT = 'INPUT'
export const OUTPUT = 'OUTPUT'
export const MOVABLE = 'MOVABLE'
export const MODULE = 'MODULE'
// CEEA+ outputs named with this:
export const DRIVER = 'DRIVER'

// module_connector strings, collections
export const BHM_C1C = 'BHM_C1C'
export const BHM_C2C = 'BHM_C2C'
export const BHM_C3C = 'BHM_C3C'
export const BHM_C4C = 'BHM_C4C'
export const BHM_C5C = 'BHM_C5C'
export const BHM_C6C = 'BHM_C6C'
export const BHM_C7C = 'BHM_C7C'

export const CHM_C1C = 'CHM_C1C'
export const CHM_C2C = 'CHM_C2C'
export const CHM_C3C = 'CHM_C3C'
export const CHM_C4C = 'CHM_C4C'
export const CHM_C5C = 'CHM_C5C'

export const CHM_C1 = 'CHM_C1'
export const CHM_C2 = 'CHM_C2'
export const CHM_C3 = 'CHM_C3'
export const CHM_C4 = 'CHM_C4'
export const CHM_C5 = 'CHM_C5'

export const EXM1_C1 = 'EXM1_C1'
export const EXM1_C2 = 'EXM1_C2'
export const EXM1_C3 = 'EXM1_C3'
export const EXM1_C4 = 'EXM1_C4'
export const EXM1_C5 = 'EXM1_C5'

export const EXM2_C1 = 'EXM2_C1'
export const EXM2_C2 = 'EXM2_C2'
export const EXM2_C3 = 'EXM2_C3'
export const EXM2_C4 = 'EXM2_C4'
export const EXM2_C5 = 'EXM2_C5'

export const EXM3_C1 = 'EXM3_C1'
export const EXM3_C2 = 'EXM3_C2'
export const EXM3_C3 = 'EXM3_C3'
export const EXM3_C4 = 'EXM3_C4'
export const EXM3_C5 = 'EXM3_C5'

export const DASH_O_J1 = 'DASH_O_J1'
export const DASH_O_J2 = 'DASH_O_J2'
export const DASH_O_J3 = 'DASH_O_J3'

export const SMARTPLEX_1A = 'SmartPlex_1A'
export const SMARTPLEX_2A = 'SmartPlex_2A'

// CEEA+
const ASAM_X7 = 'ASAM_X7'
const XMC1_X1 = 'XMC1_X1'
const XMC1_X2 = 'XMC1_X2'
const XMC1_X3 = 'XMC1_X3'
const XMC2_X1 = 'XMC2_X1'
const XMC2_X2 = 'XMC2_X2'
const XMC2_X3 = 'XMC2_X3'
const XMC3_X1 = 'XMC3_X1'
const XMC3_X2 = 'XMC3_X2'
const XMC3_X3 = 'XMC3_X3'
const XMC4_X1 = 'XMC4_X1'
const XMC4_X2 = 'XMC4_X2'
const XMC4_X3 = 'XMC4_X3'
const XMC5_X1 = 'XMC5_X1'
const XMC5_X2 = 'XMC5_X2'
const XMC5_X3 = 'XMC5_X3'
const XMC6_X1 = 'XMC6_X1'
const XMC6_X2 = 'XMC6_X2'
const XMC6_X3 = 'XMC6_X3'

export const X1 = 'X1'
export const X2 = 'X2'
export const X3 = 'X3'
export const X7 = 'X7'

// Interface
const INTERFACE_EXT1 = 'interface_EXT1'
const INTERFACE_INT1 = 'interface_INT1'
const INTERFACE_EXT2 = 'interface_EXT2'
const INTERFACE_INT2 = 'interface_INT2'
const INTERFACE_EXT3 = 'interface_EXT3'
const INTERFACE_INT3 = 'interface_INT3'
const INTERFACE_EXT4 = 'interface_EXT4'
const INTERFACE_INT4 = 'interface_INT4'
const INTERFACE_INT5 = 'interface_INT5'
const INTERFACE_EXT5 = 'interface_EXT5'
const INTERFACE_EXT6 = 'interface_EXT6'
const INTERFACE_INT6 = 'interface_INT6'

export const CONNECTORS_LIST = Object.freeze({
  BHM_C1C,
  BHM_C2C,
  BHM_C3C,
  BHM_C4C,
  BHM_C5C,
  BHM_C6C,
  BHM_C7C,
  CHM_C1C,
  CHM_C1,
  EXM1_C1,
  EXM2_C1,
  EXM3_C1,
  CHM_C2C,
  CHM_C2,
  EXM1_C2,
  EXM2_C2,
  EXM3_C2,
  CHM_C3C,
  CHM_C3,
  EXM1_C3,
  EXM2_C3,
  EXM3_C3,
  CHM_C4C,
  CHM_C4,
  EXM1_C4,
  EXM2_C4,
  EXM3_C4,
  CHM_C5C,
  CHM_C5,
  EXM1_C5,
  EXM2_C5,
  EXM3_C5,
  DASH_O_J1,
  DASH_O_J2,
  DASH_O_J3,
  ASAM_X7,
  XMC1_X1,
  XMC1_X2,
  XMC1_X3,
  XMC2_X1,
  XMC2_X2,
  XMC2_X3,
  XMC3_X1,
  XMC3_X2,
  XMC3_X3,
  XMC4_X1,
  XMC4_X2,
  XMC4_X3,
  XMC5_X1,
  XMC5_X2,
  XMC5_X3,
  XMC6_X1,
  XMC6_X2,
  XMC6_X3,
  INTERFACE_EXT1,
  INTERFACE_INT1,
  INTERFACE_EXT2,
  INTERFACE_INT2,
  INTERFACE_EXT3,
  INTERFACE_INT3,
  INTERFACE_EXT4,
  INTERFACE_INT4,
  INTERFACE_INT5,
  INTERFACE_EXT5,
  INTERFACE_INT6,
  INTERFACE_EXT6,
  SMARTPLEX_1A,
  SMARTPLEX_2A,
})

export const mLogics = [O_MLOGIC, N_MLOGIC, N_MLOGIC2]
export const slotCopies = [N_SLOTCOPY, O_SLOTCOPY]

export const QUERY_INPUT_TYPES = Object.freeze({
  DIGITAL_INPUT,
  ANALOG_INPUT,
  CARRY,
  CAN_INPUT,
  NATIVE_INPUT,
  SWITCH_INPUT,
})
export const rowidLogicalSlotOffsets = {
  N_TIMER: 151,
  N_MLOGIC2: 375,
  N_MLOGIC: [131, 320],
}
export const rowidLogicalSlotOffsetsRV = {
  ...rowidLogicalSlotOffsets,
  N_TIMER: 261,
}

export const CHECPLUS_CAN_OUTPUT_IDS = Object.freeze({
  // '2' and other number props indicate number of bits of the configured CAN output.
  [XMC1]: {
    2: '14FF0DE6',
    16: '14FF06E6',
  },
  [XMC2]: {
    2: '14FF0E8C',
    16: '14FF068C',
  },
  [XMC3]: {
    2: '14FF0E8D',
    16: '14FF088D',
  },
  [XMC4]: {
    2: '14FF0E8E',
    16: '14FF088E',
  },
  [XMC5]: {
    2: '14FF0D8F',
    16: '14FF058F',
  },
  [XMC6]: {
    2: '14FF0D90',
    16: '14FF0590',
  },
  [XMC7]: {
    2: '14FF0D91',
    16: '14FF0591',
  },
  [XMC8]: {
    2: '14FF0D92',
    16: '14FF0592',
  },
  [XMC9]: {
    2: '14FF0D84',
    16: '14FF0584',
  },
  [ASAM]: {
    16: '14FF0A21',
  },
})

export const MODULE_MAX_PINS = Object.freeze({
  [XMC1]: 34,
  [XMC2]: 34,
  [XMC3]: 34,
  [XMC4]: 34,
  [XMC5]: 34,
  [XMC6]: 34,
  [ASAM]: 32,
})

export const MAX_SWITCH_INDICATORS = 15
export const MAX_CAN_INPUTS = 32

export const CAN_ID_STRING_LENGTH = 8
export const CAN_GRID_TOTAL_NUMBER_OF_BITS = 64
export const AUTOMATIC = 'AUTOMATIC'
export const IGNITION = 'IGNITION'
export const RESET_TYPES = Object.freeze({
  [AUTOMATIC]: 'AUTOMATIC',
  [IGNITION]: 'IGNITION',
})

export const AMPS2 = 2
export const AMPS5 = 5
export const AMPS20 = 20
export const MIN_FREQUENCY = 20
export const MAX_FREQUENCY = 150
export const MIN_DUTY_CYCLE = 10
export const MAX_DUTY_CYCLE = 50

export const BITS = range(0, 64)
export const BYTES = range(0, 8)
export const TWO_BIT_OUTPUT_MAX_INDEX_AVAILABLE = 33
export const MAX_BITS = BITS.length

const BROWN = 'Brown'
const BLUE = 'Blue'
const RED = 'Red'
const GREEN = 'Green'
const BLACK = 'Black'
const WHITE = 'White'
const TAN = 'Tan'
const YELLOW = 'Yellow'
const SILVER = 'Silver'
const PURPLE = 'Purple'
const DARK_GREEN = 'Dark Green'
const ORANGE = 'Orange'

export const COLLET_COLORS = Object.freeze({
  BROWN,
  BLUE,
  RED,
  GREEN,
  BLACK,
  WHITE,
  TAN,
  YELLOW,
  SILVER,
  PURPLE,
  DARK_GREEN,
  ORANGE,
})

export const NONE = 'none'

export const linkedLogicListKeysByTruckType = Object.freeze({
  [VEHICLE_TYPE_M2]: ['uri', 'itemDescription', 'refParameterNumber'],
  [VEHICLE_TYPE_CHEC_PLUS]: ['uri', 'description', 'partNumber'],
})

export const DYNAMIC = 'DYNAMIC'
export const PANEL_PART = 'PANEL_PART'
export const LIST = 'LIST'
export const NOT_FOUND = 'NOT_FOUND'
export const NOT_FOUND_QR = 'NOT_FOUND_QR'
export const TIME_OUT_QR = 'TIME_OUT_QR'
export const TABLE = 'TABLE'
export const RESET = 'RESET'
export const SAVE = 'SAVE'
export const ERROR = 'ERROR'
export const REMOVE = 'REMOVE'
export const REMOVED = 'REMOVED'
export const ADD = 'ADD'
export const WARNING = 'WARNING'

export const TRUCK_SUBTYPE_43N = '43N'
export const TRUCK_SUBTYPE_42N = '42N'
export const TRUCK_SUBTYPE_38N = '38N'
export const TRUCK_SUBTYPE_BUS = 'BUS'
export const TRUCK_SUBTYPE_45X = '45X'

export const CHEC_PLUS_VEHICLE_SUBTYPES = [
  TRUCK_SUBTYPE_43N,
  TRUCK_SUBTYPE_42N,
  TRUCK_SUBTYPE_38N,
]

export const RESOURCE_TYPES = {
  TIMERS: 'timers',
  LOGICS: 'logics',
}
export const FLOATING_CIRCUIT = 'FLOATING_CIRCUIT'
export const MASTER_RP_NUMBER_32AP1 = '32AP1'
export const VEHICLE_SERIAL_NUMBER_LENGTH = 6
export const SOLENOID = 'SOLENOID'
export const UNSUPPORTED = 'UNSUPPORTED'
export const NOTFOUND = 'NOTFOUND'
export const Modal_DROPDOWN = 'Modal_dropdown'
export const ERROR_CODES_DROPDOWN = 'error_codes_dropdown'
export const CUSTOMER_DROPDOWN = 'customer_dropdown'
export const PRODUCT_DESCRIPTION_DROPDOWN = 'product_description_dropdown'
export const LOCATION_DROPDOWN = 'location_dropdown'

export const QUICK_FIT_LOGIC_AND_PTO = 'QUICK_FIT_LOGIC_AND_PTO'
export const QUICK_FIT_LOGIC = 'QUICK_FIT_LOGIC'

export const DASH_PANEL_DROPDOWN = 'DASH_PANEL_DROPDOWN'
export const OVERHEAD_PANEL_DROPDOWN = 'OVERHEAD_PANEL_DROPDOWN'
export const SEARCH = 'SEARCH'
export const SEARCH_COLLECTIONS = 'SEARCH_COLLECTIONS'
export const SEARCH_TABLE_COLLECTION = 'SEARCH_TABLE_COLLECTION'
export const SEARCH_TABLE = 'SEARCH_TABLE'
export const RP_TABLE = 'RP_TABLE'
export const COMMIT = 'COMMIT'
export const REVIEW_COLLECTION = 'REVIEW_COLLECTION'
export const NOT_SUPPORTED = 'NOT_SUPPORTED'
export const ODX_DATA_TRANSLATOR = 'ODX_DATA_TRANSLATOR'

export const CERTIFICATION_TO_EDIT_REQUIRED = 'CERTIFICATION_TO_EDIT_REQUIRED'
export const BHM_LIMITED_MODULE_VERSION = '7.44'
export const BHM_CHM_LIMITED_MODULE = 'BHM_CHM_LIMITED_MODULE'

export const MAX_XMC_ALLOWED = 4
export const MAX_XMC_ALLOWED_FOR_38N = 2

export const ADD_REMOVE_FEATURES = 'ADD_REMOVE_FEATURES'
export const ADD_REMOVE_FEATURE_COLLECTIONS = 'ADD_REMOVE_FEATURE_COLLECTIONS'
export const APPLY_FAST_FEATURES = 'APPLY_FAST_FEATURES'
export const ADD_REF_PARAMETERS_WORKFLOW = 'ADD_REF_PARAMETERS_WORKFLOW'
export const SHOW_FAVOURITE_VEHICLES = 'SHOW_FAVOURITE_VEHICLES'
export const SHOW_VEHICLE_SNAPSHOTS = 'SHOW_VEHICLE_SNAPSHOTS'
export const SHOW_VEHICLE_COMMENTS = 'SHOW_VEHICLE_COMMENTS'
export const BATCH_IMPORT = 'BATCH_IMPORT'
export const DASH_VIEW = 'DASH_VIEW'
export const LAYOUT_LOCATION_EDIT = 'LAYOUT_LOCATION_EDIT'
export const SAVE_LAYOUT = 'SAVE_LAYOUT'
export const ASC = 'ASC'
export const DESC = 'DESC'
export const LOGIC_SETS = 'LOGIC_SETS'
export const TIMERS = 'TIMERS'
export const CAN_INPUTS = 'CAN_INPUTS'
export const SWITCH_INDICATORS = 'SWITCH_INDICATORS'
export const FEATURE_NOTES = 'FEATURE_NOTES'
